'use client'
import type { Data } from '@repo/strapi'
import AppLink from '@/components/elementary/AppLink'
import CkEditorCSRRenderer from '@/components/elementary/CkEditorRenderer/CkEditorCSRRenderer'
import { KnockAi } from '@/components/elementary/KnockAi'
import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/styles'

export const PricingCardFooter = ({
	pricingItem,
	yearly = false,
	className,
}: {
	pricingItem?: Data.Component<'shared.pricing-item'> | null
	yearly?: boolean
	className?: string
}) => {
	const priceDescription = yearly
		? (pricingItem?.descriptionYearly ?? pricingItem?.descriptionMonthly)
		: pricingItem?.descriptionMonthly

	return (
		<div className={cn('flex flex-col gap-5 pb-8 px-4', className)}>
			{pricingItem?.link?.href && (
				<AppLink
					openExternalInNewTab={pricingItem.link?.newTab ?? false}
					href={pricingItem.link?.href}
					variant="primary"
					size="medium"
				>
					{pricingItem.link?.label}
				</AppLink>
			)}

			{pricingItem?.knockAiId && (
				<KnockAi
					dataId={pricingItem?.knockAiId}
					skeleton={
						<>
							<Skeleton className={cn('max-w-[250px] w-full h-[45px] rounded-full')} />
							<Skeleton className={cn('max-w-[170px] w-full h-[50px] rounded-')} />
						</>
					}
				/>
			)}
			<CkEditorCSRRenderer
				htmlContent={priceDescription}
				className={priceDescription ? '-mb-6' : ''}
			/>
		</div>
	)
}

export default PricingCardFooter
